<template>
  <div class="box">
    <div class="box2">
      <div class="complaintInformation">
        <div class="complaintClassification border_bottom" @click="showBox(0)">
          <div class="left">投诉分类</div>
          <div class="right" :class="{'rightSelt':typeText!=='请选择'}">
            <span>{{typeText}} ></span>
          </div>
        </div>
        <div class="objectofcomplaint border_bottom"  @click="showBox1(1)">
          <div class="left">被投诉对象</div>
          <div class="right" :class="{'rightSelt':personType!=='请选择'}">
            <span>{{personType}} ></span>
          </div>
        </div>
        <div class="complaint border_bottom" @click="showBox2(2)">
          <div class="left">投诉问题</div>
          <div class="right" :class="{'rightSelt':qustionType!=='请选择'}">
            <span>{{qustionType}} ></span>
          </div>
        </div>
        <div class="specificSituation border_bottom" @click="showBox3(3)">
          <div class="left">具体情形</div>
          <div class="right" :class="{'rightSelt':aboutType!=='请选择'}">
            <span>{{aboutType}} ></span>
          </div>
        </div>
      </div>
      <div class="urgent">
        <div class="complaintClass border_bottom">
          <div class="left">投诉分类</div>
          <div class="right">
            <!-- <div class="Complaint" :class="{tabColor:Complaints===true}" @click="Complaint">投诉</div>
            <div class="Suggest" :class="{tabColor:Suggests===true}" @click="Suggest">建议</div> -->
            <div class="Complaint" :class="{tabColor:SuggestIndex==5}" @click="Complaint(5)">投诉</div>
            <div class="Suggest" :class="{tabColor:SuggestIndex===6}" @click="Complaint(6)">建议</div>
            <div style="width:50px;height:0;"></div>
          </div>
        </div>
        <div class="emergencyLabel border_bottom">

          <div class="left">紧急程度</div>
          <div class="right">
            <!-- <div class="general" :class="{tabColor:generals===true}" @click="general">一般</div>
            <div class="heavier" :class="{tabColor:heaviers===true}" @click="heavier">较重</div>
            <div class="serious" :class="{tabColor:seriouss===true}" @click="serious">严重</div> -->
            <div class="general" :class="{tabColor:limitIndex===7}" @click="general(7)">一般</div>
            <div class="heavier" :class="{tabColor1:limitIndex===8}" @click="general(8)">较重</div>
            <div class="serious" :class="{tabColor2:limitIndex===9}" @click="general(9)">严重</div>
          </div>
        </div>
        <div class="specificSituation border_bottom">
          <div class="left">赔偿金额</div>
          <div class="right right_t">
            <input type="number" placeholder="请输入赔偿金额" v-model="price">
            <span style="position:relative;z-index:100">元</span>
          </div>
        </div>
        <div class="specificSituation border_bottom">
          <div class="left">履行地点</div>
          <div class="right">
            <input type="text" placeholder="请输入履行地点" v-model="address">
          </div>
        </div>
        <div class="returnReas">
            <div class="text">事实经过</div>
            <div class="textar">
                    <textarea  maxlength="200" placeholder="请输入事实经过" class="txtarea" @input="change" v-model="reson"></textarea>
                    <span class="total">{{currentTotal}}/200</span>
            </div>
        </div>
        <div class="returnReas">
            <div class="text">达成协议</div>
            <div class="textar">
                    <textarea  maxlength="200" placeholder="请输入达成协议" class="txtarea" @input="change1" v-model="reson1"></textarea>
                    <span class="total">{{currentTotal1}}/200</span>
            </div>
        </div>
         <div class="uploadBox">
              <upload :imgUrl="imgUrl"></upload>
          </div>
        <div class="btn" @click="send">提交</div>
      </div>
    </div>
    <van-action-sheet v-model="isshowBox1" :actions="actions" @select="onSelect" title="请选择"/>
    <van-action-sheet v-model="isshowBox2" :actions="actions1" @select="onSelect" title="请选择"/>
    <van-action-sheet v-model="isshowBox3" :actions="actions2" @select="onSelect" title="请选择"/>
    <van-action-sheet v-model="isshowBox4" :actions="actions3" @select="onSelect" title="请选择"/>
  </div>
</template>
<script>
    import util from '@/utils/common'
    import api from '@/service/modules/complaint';
    import upload from '@/components/uploadCopy'
    export default {
        components: {
            upload
        },
        data () {
            return {
                tab: ['一般', '较重', '严重'],
                Complaints: true,
                Suggests: false,
                generals: true,
                heaviers: false,
                seriouss: false,
                classify: '',
                objectlist: '',
                one: '',
                two: '',
                reson: '',
                reson1: '',
                currentTotal: 0,
                currentTotal1: 0,
                limitIndex: 7,
                SuggestIndex: 5,
                typeText: '请选择',
                personType: '请选择',
                qustionType: '请选择',
                aboutType: '请选择',
                itemList: util.getJsonLocal('item'),
                isback:this.$store.state.complaint.isBackDetail||util.getJsonLocal('isBack'),
                tab: ['一般', '较重', '严重'],
                pid: 0,
                isshowBox1: false,
                isshowBox2: false,
                isshowBox3: false,
                isshowBox4: false,
                actions: [],
                actions1: [],
                actions2: [],
                actions3: [],
                selectIndex: 0,
                price: '',
                address: '',
                imgUrl: [] // 上传的图片

            }
        },
        created () {
            this.getType();
        },
        mounted () {
            this.$on('fileUploadData', val => {
                this.imgUrl = val
            })
        },
        methods: {
            getType () { // 获取投诉分类
                api.ComplainTypeList({ 'pid': 0, 'complainType': 'levels' }).then((res) => {
                    if (res.ret === 0) {
                        if (res.data.objArrays.length > 0) {
                            this.actions = res.data.objArrays;
                        }
                    }
                })
            },
            getType1 () { // 获取分类
                api.ComplainTypeList({ 'pid': this.pid, 'complainType': 'levels' }).then((res) => {
                    if (res.ret === 0) {
                        if (res.data.objArrays.length > 0) {
                            this.actions1 = res.data.objArrays;
                        }
                    }
                })
            },
            getType2 () { // 获取分类
                api.ComplainTypeList({ 'pid': this.pid, 'complainType': 'levels' }).then((res) => {
                    if (res.ret === 0) {
                        if (res.data.objArrays.length > 0) {
                            this.actions2 = res.data.objArrays;
                        }
                    }
                })
            },
            getType3 () { // 获取分类
                api.ComplainTypeList({ 'pid': this.pid, 'complainType': 'levels' }).then((res) => {
                    if (res.ret === 0) {
                        if (res.data.objArrays.length > 0) {
                            this.actions3 = res.data.objArrays;
                        }
                    }
                })
            },
            showBox (index) {
                this.selectIndex = index;
                this.isshowBox1 = true;
            },
            showBox1 (index) {
                console.log(this.actions1);
                this.selectIndex = index;

                if (this.typeText === '请选择') {
                    this.$Toast('请先选择投诉分类');
                } else {
                    this.isshowBox2 = true;
                }
            },
            showBox2 (index) {
                this.selectIndex = index;
                if (this.typeText === '请选择') {
                    this.$Toast('请先选择投诉分类');
                } else if (this.personType === '请选择') {
                    this.$Toast('请先选择被投诉对象');
                } else {
                    this.isshowBox3 = true;
                }
            },
            showBox3 (index) {
                this.selectIndex = index;
                if (this.typeText === '请选择') {
                    this.$Toast('请先选择投诉分类');
                } else if (this.personType === '请选择') {
                    this.$Toast('请先选择被投诉对象');
                } else if (this.qustionType === '请选择') {
                    this.$Toast('请先选择投诉问题');
                } else {
                    this.isshowBox4 = true;
                }
            },
            Complaint (value) {
                this.SuggestIndex = value;
            },
            general (value) {
                this.limitIndex = value;
            },
            onSelect (item) {
                if (this.selectIndex === 0) {
                    this.pid = item.id;
                    this.typeText = item.name;
                    this.isshowBox1 = false;
                    this.actions1 = [];
                    this.actions2 = [];
                    this.actions3 = [];
                    this.personType = '请选择';
                    this.qustionType = '请选择';
                    this.aboutType = '请选择';
                    this.classify = item.id;
                    this.getType1();
                } else if (this.selectIndex === 1) {
                    this.personType = item.name;
                    this.pid = item.id;
                    this.isshowBox2 = false;
                    this.actions2 = [];
                    this.actions3 = [];
                    this.qustionType = '请选择';
                    this.aboutType = '请选择';
                    this.objectlist = item.id;
                    this.getType2();
                } else if (this.selectIndex === 2) {
                    this.qustionType = item.name;
                    this.pid = item.id;
                    this.isshowBox3 = false;
                    this.actions3 = [];
                    this.aboutType = '请选择';
                    this.one = item.id;
                    this.getType3();
                } else if (this.selectIndex === 3) {
                    this.aboutType = item.name;
                    this.isshowBox4 = false;
                    this.two = item.id
                }
            },
            change () {
                this.currentTotal = this.reson.trim().length;
            },
            change1 () {
                this.currentTotal1 = this.reson1.trim().length;
            },
            send () {
                let userInfo = this.$store.state.complaint.userInfo
                
                // console.log(data);
                if (this.typeText === '请选择') {
                    this.$Toast('请先选择投诉分类');
                } else if (this.personType === '请选择') {
                    this.$Toast('请先选择被投诉对象');
                } else if (this.qustionType === '请选择') {
                    this.$Toast('请先选择投诉问题');
                } else if (this.aboutType === '请选择') {
                    this.$Toast('请先选择具体情形');
                } else if (this.price.trim().length === 0) {
                    this.$Toast('赔偿金额不能为空');
                }else if (this.address.trim().length === 0) {
                    this.$Toast('请填写履行地点');
                }
                else if (this.reson.trim().length === 0||this.reson.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"")==='') {
                    this.$Toast('请填写事实经过');
                } else if (this.reson1.trim().length === 0||this.reson1.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"")==='') {
                    this.$Toast('请填写达成协议');
                } else {
                    // this.reson=this.reson.trim();
                    // this.reson1=this.reson1.trim();
                    var resultReson=this.reson.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"");
                    var resultReson1=this.reson1.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"");
                    // console.log(resultContent.replace(/\s*/g,""))
                    if(resultReson.replace(/\s*/g,"").length<=10){
                        // this.$Toast('事实经过需大于10个字符');
                        this.$Toast('请输入10个字以上的事实经过');
                        return;
                    }else if(resultReson1.replace(/\s*/g,"").length<=10){
                        this.$Toast('请输入10个字以上的协议内容');
                        return;
                    }else{
                         const data = {
                          main_complain_number: this.itemList.main_complain_number,
                          complain_12301_number: this.itemList.complain_12301_number,
                          classify: this.classify,
                          object: this.objectlist,
                          one: this.one,
                          two: this.two,
                          category: this.SuggestIndex,
                          sub_id: this.itemList.sub_id,
                          urgency_degree: this.limitIndex,
                          type: 'conciliationSuccess',
                          result_type: '3', // 4表示调节失败，3表示调节成功
                          fact: this.reson.replace(/\s*/g,""),
                          address: this.address.trim(),
                          agreement: this.reson1.replace(/\s*/g,""),
                          money: this.price.trim(),
                          imgUrl: this.imgUrl
                      }
                        api.accept(data).then((res) => {
                            console.log(res);
                            if (res.ret === 0) {
                                this.$Toast('操作成功');
                                // this.$router.go(-2);
                                if(!this.isback){
                                this.$router.go(-2);
                                }else{
                                    this.$router.back();
                                    this.$set(this.itemList,'btns',[]);
                                    util.setJsonLocal('item',this.itemList);
                                }
                            }
                        })
                      }
                    
                }
            }
        }

    }
</script>
<style lang="less" scoped>
.box {
  width: 100%;
//   padding: 14px;
  background-color: #f4f3f3;
  box-sizing: border-box;
  .box2 {
    width: 100%;
    padding: 14px;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    .uploadBox{
      margin-top: 20px;
    }
    .complaintInformation {
      width: 100%;
      .complaintClassification,
      .objectofcomplaint,
      .complaint,
      .specificSituation
     {
        display: flex;
        height: 50px;
        line-height: 50px;
        .left {
          float: left;
          width: 50%;
          text-align: left;
          color: #aaa;
        }
        .right {
          float: left;
          width: 50%;
          text-align: right;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .complaintClassification,
      .objectofcomplaint,
      .complaint,
      .specificSituation {
        .right {
          color: #ddd;
        }
        .rightSelt {
          color: #000000;
        }
      }
      .complaintTarget_class {
        color: #000000;
      }
    }
    .companyName {
      height: 50px;
      line-height: 50px;
    }
    .emergencyLevel {
      width: 100%;
      height: 50px;
      line-height: 50px;
    }
    .urgent {
      width: 100%;
      font-size: 14px;
      .limitedProcesseTime {
        width: 100%;
        height: 50px;
        line-height: 50px;
        display: flex;
        .left {
          width: 40%;
          color: #aaa;
        }
        .right {
          width: 55%;
          margin-left: 15px;
          display: flex;
          .van-field {
            border-bottom: 1px solid #ccc;
            height: 30px;
            margin-top: 10px;
            padding: 0;
          }
          span {
            color: #aaa;
          }
        }
      }
        .van-uploader {
                margin-top: 20px;
            }
      .upload{
            min-height: 44px;
            line-height: 50px;

            .upattach{
                font-size: 14px;
                color: #444444;
            }
            span{
                font-size: 12px;
                color: #BFBFBF;
            }
        }
        .btn {
            width: 100%;
            height: 46px;
            background-color: #36B374;
            line-height: 46px;
            color: #fff;
            text-align: center;
            font-size: 14px;
            border-radius: 5px;
        }
        .returnReas{
            font-size: 14px;
            margin-top:15px;
            .text{
                height: 20px;
                // color: #9C9C9C;
                color: #BFBFBF;
                // margin-left: 0.426667rem;
                padding-bottom:15px;
            }
            .textar{
                margin-top: 5px;
                height: 110px;
                width: 100%;
                text-align: center;
                position: relative;
                .txtarea{
                    border: none;
                    border-radius: 5px;
                    padding-top: 10px;
                    padding-left: 10px;
                    background-color:#F2F2F2;
                    height: 100px;
                    width: 340px;
                    resize: none;
                }
                .total{
                  position: absolute;
                  right:6px;
                  bottom:6px;
                }
            }
        }
      .emergencyLabel,
      .complaintClass {
        width: 100%;
        height: 50px;
        line-height: 50px;
        display: flex;
        .left {
          width: 30%;
          color: #aaa;
        }
        .right {
          display: flex;
          width: 50%;
          justify-content: space-between;
          div {
            width: 50px;
            height: 30px;
            line-height: 30px;
            margin-top: 10px;
            text-align: center;
            background-color: #fff;
            color: #aaa;
          }
          .tabColor {
            background-color: #36B374;
            color: #fff;
          }
          .tabColor1 {
            background-color: #E6611E;
            color: #fff;
          }
          .tabColor2 {
            background-color: red;
            color: #fff;
          }
        }
      }
    }
    .btn {
      margin-top: 30px;
      .van-button {
        width: 100%;
        border-radius: 7px;
        margin-top: 10px;
      }
      .back {
        .van-button {
          color: #bdb8b8;
        }
        .van-button--plain {
          background-color: #efeded;
        }
      }
    }
    .border_bottom {
      border-bottom: 1px solid #eee;
    }
    .specificSituation {
        display: flex;
        line-height: 50px;
        justify-content: space-between;
        .left {
          text-align: left;
          color: #aaa;
        }
        .right {
          text-align: right;
          input {
              text-align: right;
              padding-right: 5px;
          }
        }
        .right_t {
          display: flex;
        }
      }
  }
}
</style>
